import {MultiCurrencyPriceFragment} from '../../../gql/graphql';
import {ModelContext} from '../../../types/checkoutApp.types';
import {SPECS} from '../../../common/constants';

export class PriceModel {
  public amount: number;
  public formattedAmount: string;

  constructor(price: MultiCurrencyPriceFragment | undefined | null, modelContext: ModelContext) {
    this.amount = Number(modelContext.useConvertedPrice ? price?.convertedAmount : price?.amount) || 0;
    this.formattedAmount = modelContext.flowAPI.experiments.enabled(SPECS.ClientFormattingForPrices)
      ? modelContext.formatAmount(modelContext.useConvertedPrice ? price?.convertedAmount ?? '' : price?.amount ?? '')
      : (modelContext.useConvertedPrice ? price?.formattedConvertedAmount : price?.formattedAmount) ?? '';
  }
}
